import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import EmpathySection from './components/EmpathySection';
import FeaturesSection from './components/FeaturesSection';
import PricingSection from './components/PricingSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 via-purple-50 to-yellow-50">
      {/* Floating Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 sm:h-20">
            <div className="flex items-center space-x-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/6b1b462e-7702-4dd8-a6c7-86963b54e045.png" 
                alt="キッズPCスクール" 
                className="h-8 sm:h-12 w-auto"
              />
            </div>
            
            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
              <a href="#features" className="text-sm lg:text-base text-gray-700 hover:text-pink-500 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">スクールの特徴</a>
              <a href="#pricing" className="text-sm lg:text-base text-gray-700 hover:text-pink-500 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">料金プラン</a>
              <a href="#testimonials" className="text-sm lg:text-base text-gray-700 hover:text-pink-500 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">保護者の声</a>
              <a href="#faq" className="text-sm lg:text-base text-gray-700 hover:text-pink-500 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">よくある質問</a>
              <a href="#trial" className="bg-gradient-to-r from-pink-400 to-purple-400 text-white px-4 lg:px-6 py-2 lg:py-3 rounded-full font-bold hover:shadow-lg transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm lg:text-base">
                無料体験申込
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-pink-500 transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden bg-white/95 backdrop-blur-sm shadow-lg rounded-b-2xl py-4 px-4 space-y-3">
              <a href="#features" className="block text-gray-700 hover:text-pink-500 transition-colors duration-300 font-medium py-2 cursor-pointer" onClick={() => setMobileMenuOpen(false)}>スクールの特徴</a>
              <a href="#pricing" className="block text-gray-700 hover:text-pink-500 transition-colors duration-300 font-medium py-2 cursor-pointer" onClick={() => setMobileMenuOpen(false)}>料金プラン</a>
              <a href="#testimonials" className="block text-gray-700 hover:text-pink-500 transition-colors duration-300 font-medium py-2 cursor-pointer" onClick={() => setMobileMenuOpen(false)}>保護者の声</a>
              <a href="#faq" className="block text-gray-700 hover:text-pink-500 transition-colors duration-300 font-medium py-2 cursor-pointer" onClick={() => setMobileMenuOpen(false)}>よくある質問</a>
              <a href="#trial" className="block bg-gradient-to-r from-pink-400 to-purple-400 text-white px-6 py-3 rounded-full font-bold text-center hover:shadow-lg transition-all duration-300 cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
                無料体験申込
              </a>
            </div>
          )}
        </div>
      </nav>

      <Hero />
      <EmpathySection />
      <FeaturesSection />
      <PricingSection />
      <TestimonialsSection />
      <FAQSection />
      <Footer />
    </div>
  );
}
